import { render, staticRenderFns } from "./MemberRegist.vue?vue&type=template&id=bb4a99da&scoped=true&"
import script from "./MemberRegist.vue?vue&type=script&lang=js&"
export * from "./MemberRegist.vue?vue&type=script&lang=js&"
import style0 from "./MemberRegist.vue?vue&type=style&index=0&id=bb4a99da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4a99da",
  null
  
)

export default component.exports